

import React, { useEffect, useState,useRef} from "react";
import { useSelector, useDispatch } from "react-redux";

import { updateStyling } from "../../services/redux/reducers/customFormBuildeSclice.js";
import { defaultComponentStyle } from "./elementsDefaultStyling.js";
import RichTextEditor from "./draggableFileds/richTextEditor.js";
function FormBuilderPropertiesPanel({ element, onPropertiesChange } = {}) {
  const dispatch = useDispatch();
  const [properties, setProperties] = useState(element?.style || {});
  const [activeSection, setActiveSection] = useState("customize");
  // Add these helper functions inside the FormBuilderPropertiesPanel component
  const getValueWithoutUnit = (value, defaultValue = "") => {
    if (!value) return defaultValue;
    const match = String(value).match(/^([\d.]+)/);
    return match ? match[1] : defaultValue;
  };

  const getUnitFromValue = (value, defaultUnit = "px") => {
    if (!value) return defaultUnit;
    const match = String(value).match(/([a-z%]+)$/);
    return match ? match[1] : defaultUnit;
  };

  // Modified handlePropertyChange for numeric inputs
  const handleNumericInputChange = (e) => {
    const { name, value } = e.target;
    const currentUnit = getUnitFromValue(properties[name], "px");

    // Preserve the existing unit when updating the value
    handlePropertyChange(name, `${value}${currentUnit}`);
  };
  // Add these helper functions inside the FormBuilderPropertiesPanel component
  const parseValueAndUnit = (value) => {
    if (!value) return { value: "", unit: "px" };

    const match = value.match(/^([\d.]+)([a-z%]*)$/);
    if (match) {
      return { value: match[1], unit: match[2] || "px" };
    }

    return { value: "", unit: "px" };
  };

  const formatValueWithUnit = (value, unit) => {
    if (value === "" || value === undefined || value === null) return "";
    return `${value}${unit || "px"}`;
  };

  // Modified handlePropertyChange to handle unit inputs
  // In FormBuilderPropertiesPanel.js
  const handleUnitPropertyChange = (name, numericValue, unit) => {
    const formattedValue = formatValueWithUnit(numericValue, unit);

    // Create a deep copy of the current properties
    const updatedProperties = JSON.parse(JSON.stringify(properties));

    // Update the specific property
    updatedProperties[name] = formattedValue;

    // Update local state
    setProperties(updatedProperties);

    // Dispatch to Redux with the FULL updated properties
    dispatch(
      updateStyling({ id: element.instanceId, data: updatedProperties })
    );

    onPropertiesChange?.(updatedProperties);
  };
  // Add this component inside FormBuilderPropertiesPanel
  const UnitInput = ({
    name,
    value,
    onChange,
    placeholder,
    units = ["px", "%", "rem", "em", "vh", "vw"],
  }) => {
    const { value: numericValue, unit } = parseValueAndUnit(value);

    return (
      <div className="d-flex">
        <input
          type="number"
          className="form-control form-control-xs"
          name={name}
          value={numericValue}
          onChange={(e) => onChange(name, e.target.value, unit)}
          placeholder={placeholder}
          style={{
            fontSize: "0.7rem",
            height: "1.8rem",
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          }}
        />
        <select
          className="form-select form-select-xs"
          value={unit}
          onChange={(e) => onChange(name, numericValue, e.target.value)}
          style={{
            fontSize: "0.7rem",
            height: "1.8rem",
            width: "40%",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          }}
        >
          {units.map((u) => (
            <option key={u} value={u}>
              {u}
            </option>
          ))}
        </select>
      </div>
    );
  };
  useEffect(() => {
    setProperties(element?.style || {});
    return () => {};
  }, [element]);

  // Common function for handling property changes
  // Add this component at the top of FormBuilderProperties.js (after imports)

  const handlePropertyChange = (name, value) => {
    // Create a deep copy of current properties to avoid reference issues
    const updatedProperties = {
      ...JSON.parse(JSON.stringify(properties)),
      [name]: value,
    };

    setProperties(updatedProperties);
    console.log("Updated properties", updatedProperties);

    // Update styling in Redux store
    dispatch(
      updateStyling({
        id: element.instanceId,
        data: updatedProperties,
        updateType: "merge", // Add this flag to indicate we want to merge, not replace
      })
    );

    onPropertiesChange?.(updatedProperties);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handle checkbox separately
    if (type === "checkbox") {
      handlePropertyChange(name, checked);
      return;
    }
    if (name == "label") {
      handlePropertyChange(name, {
        ...properties.label,
        label: value,
      });
      return;
    }

    handlePropertyChange(name, value);
  };

  // Helper function to check if property exists
  const propertyExists = (propertyName) => {
    if (!element || !element.style) return false;
    return propertyName in element.style;
  };

  // Create render functions for each element type
  const renderCustomizationByElementType = () => {
    switch (element?.id || element?.type) {
      case "text-title":
        return renderTextTitleSection();
      case "text-input":
        return renderTextInputSection();
      case "number-input":
        return renderNumberInputSection();
      case "textarea":
        return renderTextareaSection();
      case "checkbox":
        return renderCheckboxSection();
      case "radio":
        return renderRadioSection();
      case "select":
        return renderSelectSection();
      case "multiSelect":
        return renderMultiSelectSection(); // Add this case
      case "file-input":
        return renderFileInputSection(); // Add this case
      case "divider":
        return renderDividerSection();
      case "text":
        return renderTextBlockSection();
      case "date":
        return renderDatePickerSection();
      case "time":
        return renderTimePickerSection();
      case "button":
        return renderButtonSection();
      case "image":
        return renderImageSection();
      case "section":
        console.log("renderSectionSettings");
        return renderSectionSettings();
      default:
        console.log("rendere DefaultSection");
        return renderDefaultSection();
    }
  };
  // Add this function inside the FormBuilderPropertiesPanel component

  const renderValidationSection = () => {
    // Skip validation for non-input elements
    if (
      !element ||
      ["divider", "text", "text-title", "button", "image", "section"].includes(
        element.id
      )
    ) {
      return (
        <div
          className={`${
            activeSection === "validate" ? "d-block" : "d-none"
          } mt-0 pt-0`}
        >
          <div className="text-center p-3">
            <i className="bi bi-info-circle fs-4 text-muted mb-2"></i>
            <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
              This element type doesn't support validation rules.
            </p>
          </div>
        </div>
      );
    }

    return (
      <div
        className={`${
          activeSection === "validate" ? "d-block" : "d-none"
        } mt-0 pt-0`}
      >
        {/* Required Field Section */}
        <div
          className="pb-2 mb-2"
          style={{ borderBottom: "1px solid #787C7EFF" }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
              Field Requirements
            </h6>
          </div>
          <div className="row g-2">
            <div className="col-6">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required Field
                </label>
              </div>
            </div>
            {/* Only show isUnique for applicable field types */}
            {["text-input", "number-input", "textarea"].includes(
              element.id
            ) && (
              <div className="col-6">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="isUnique"
                    name="isUnique"
                    checked={properties.isUnique || false}
                    onChange={handleInputChange}
                  />
                  <label
                    className="form-check-label small"
                    htmlFor="isUnique"
                    style={{ fontSize: "0.6rem" }}
                  >
                    Unique Values Only
                  </label>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Length/Value Validation Section */}
        {(element.id === "text-input" || element.id === "textarea") && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                Length Validation
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Min Length
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="minLength"
                  value={properties.minLength || ""}
                  onChange={handleInputChange}
                  placeholder="0"
                  min="0"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Max Length
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="maxLength"
                  value={properties.maxLength || ""}
                  onChange={handleInputChange}
                  placeholder="No limit"
                  min="0"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Number Range Validation */}
        {element.id === "number-input" && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                Number Range
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Min Value
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="minValue"
                  value={properties.minValue || ""}
                  onChange={handleInputChange}
                  placeholder="No min"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Max Value
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="maxValue"
                  value={properties.maxValue || ""}
                  onChange={handleInputChange}
                  placeholder="No max"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            </div>
          </div>
        )}

        {/* File Upload Validation */}
        {element.id === "file-input" && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                File Validation
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-12">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Accepted File Types
                </label>
                <input
                  type="text"
                  className="form-control form-control-xs"
                  name="acceptedFileTypes"
                  value={properties.acceptedFileTypes?.join(", ") || ""}
                  onChange={(e) =>
                    handlePropertyChange(
                      "acceptedFileTypes",
                      e.target.value.split(",").map((type) => type.trim())
                    )
                  }
                  placeholder=".jpg, .png, .pdf"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
                <small className="text-muted" style={{ fontSize: "0.55rem" }}>
                  Use file extensions (e.g., .jpg, .pdf) or MIME types
                </small>
              </div>
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Max File Size (MB)
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="maxFileSize"
                  value={properties.maxFileSize || "10"}
                  onChange={handleInputChange}
                  placeholder="10"
                  min="1"
                  max="100"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Date/Time Validation */}
        {(element.id === "date" || element.id === "time") && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                {element.id === "date" ? "Date Range" : "Time Range"}
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  {element.id === "date" ? "Min Date" : "Min Time"}
                </label>
                <input
                  type={element.id}
                  className="form-control form-control-xs"
                  name={element.id === "date" ? "minDate" : "minTime"}
                  value={
                    element.id === "date"
                      ? properties.minDate || ""
                      : properties.minTime || ""
                  }
                  onChange={handleInputChange}
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  {element.id === "date" ? "Max Date" : "Max Time"}
                </label>
                <input
                  type={element.id}
                  className="form-control form-control-xs"
                  name={element.id === "date" ? "maxDate" : "maxTime"}
                  value={
                    element.id === "date"
                      ? properties.maxDate || ""
                      : properties.maxTime || ""
                  }
                  onChange={handleInputChange}
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Custom Regex Validation */}
        {["text-input", "textarea"].includes(element.id) && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                Custom Pattern
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-12">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Regular Expression
                </label>
                <input
                  type="text"
                  className="form-control form-control-xs"
                  name="customRegex"
                  value={properties.customRegex || ""}
                  onChange={handleInputChange}
                  placeholder="^[A-Za-z0-9]+$"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
                <small className="text-muted" style={{ fontSize: "0.55rem" }}>
                  Enter a regex pattern for custom validation
                </small>
              </div>
              <div className="col-12">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Error Message
                </label>
                <input
                  type="text"
                  className="form-control form-control-xs"
                  name="customErrorMessage"
                  value={properties.customErrorMessage || ""}
                  onChange={handleInputChange}
                  placeholder="Please enter a valid format"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            </div>
          </div>
        )}

        {/* Select/MultiSelect/Radio Options Validation */}
        {["select", "multiSelect", "radio"].includes(element.id) && (
          <div
            className="pb-2 mb-2"
            style={{ borderBottom: "1px solid #787C7EFF" }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                Options Validation
              </h6>
            </div>
            <div className="row g-2">
              {element.id === "multiSelect" && (
                <>
                  <div className="col-6">
                    <label
                      className="form-label small mb-0"
                      style={{ fontSize: "0.6rem" }}
                    >
                      Min Selections
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-xs"
                      name="minSelections"
                      value={properties.minSelections || ""}
                      onChange={handleInputChange}
                      placeholder="0"
                      min="0"
                      style={{ fontSize: "0.7rem", height: "1.8rem" }}
                    />
                  </div>
                  <div className="col-6">
                    <label
                      className="form-label small mb-0"
                      style={{ fontSize: "0.6rem" }}
                    >
                      Max Selections
                    </label>
                    <input
                      type="number"
                      className="form-control form-control-xs"
                      name="maxSelections"
                      value={properties.maxSelections || ""}
                      onChange={handleInputChange}
                      placeholder="No limit"
                      min="1"
                      style={{ fontSize: "0.7rem", height: "1.8rem" }}
                    />
                  </div>
                </>
              )}
              <div className="col-12">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="allowOtherOption"
                    name="allowOtherOption"
                    checked={properties.allowOtherOption || false}
                    onChange={handleInputChange}
                  />
                  <label
                    className="form-check-label small"
                    htmlFor="allowOtherOption"
                    style={{ fontSize: "0.6rem" }}
                  >
                    Allow "Other" option with text input
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Input Type Specific Validations */}
        {/* {element.id === "text-input" && (
          <div className="pb-2 mb-2">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
                Input Type Validation
              </h6>
            </div>
            <div className="row g-2">
              <div className="col-12">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Validation Type
                </label>
                <select
                  className="form-select form-select-xs"
                  name="inputType"
                  value={properties.inputType || "text"}
                  onChange={handleInputChange}
                  style={{ fontSize: "0.7rem", height: "2rem" }}
                >
                  <option value="text">Text (No validation)</option>
                  <option value="email">Email Address</option>
                  <option value="mobile">Phone Number</option>
                  <option value="url">Website URL</option>
                </select>
                <small className="text-muted" style={{ fontSize: "0.55rem" }}>
                  Built-in validation patterns for common input types
                </small>
              </div>
              {properties.inputType === "mobile" && (
                <div className="col-12">
                  <label
                    className="form-label small mb-0"
                    style={{ fontSize: "0.6rem" }}
                  >
                    Phone Format
                  </label>
                  <select
                    className="form-select form-select-xs"
                    name="phoneFormat"
                    value={properties.phoneFormat || "international"}
                    onChange={handleInputChange}
                    style={{ fontSize: "0.7rem", height: "2rem" }}
                  >
                    <option value="international">
                      International (+1234567890)
                    </option>
                    <option value="us">US Format ((123) 456-7890)</option>
                    <option value="simple">Simple (1234567890)</option>
                  </select>
                </div>
              )}
            </div>
          </div>
        )} */}

        {/* Reset Validation Button */}
        <div className="text-center pt-2">
          <button
            className="btn btn-outline-secondary btn-xs"
            onClick={() => {
              // Reset only validation-related properties
              const resetValidationProps = {
                ...properties,
                isRequired: false,
                isUnique: false,
                minLength: undefined,
                maxLength: undefined,
                minValue: undefined,
                maxValue: undefined,
                minDate: undefined,
                maxDate: undefined,
                minTime: undefined,
                maxTime: undefined,
                customRegex: "",
                customErrorMessage: "",
                minSelections: undefined,
                maxSelections: undefined,
                allowOtherOption: false,
                phoneFormat: "international",
              };

              setProperties(resetValidationProps);
              dispatch(
                updateStyling({
                  id: element.instanceId,
                  data: resetValidationProps,
                })
              );
              onPropertiesChange?.(resetValidationProps);
            }}
            style={{ fontSize: "0.6rem", padding: "0.15rem 0.5rem" }}
          >
            <i className="bi bi-arrow-counterclockwise me-1"></i>
            Reset Validation
          </button>
        </div>
      </div>
    );
  };

  // Updated renderMultiSelectSection function for FormBuilderPropertiesPanel.js

  const renderMultiSelectSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["multiSelect"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* MultiSelect Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            multiSelect Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("options") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Options (comma-separated)
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="options"
                value={properties.options?.join(", ") || ""}
                onChange={(e) =>
                  handlePropertyChange(
                    "options",
                    e.target.value.split(",").map((opt) => opt.trim())
                  )
                }
                placeholder="Option 1, Option 2, Option 3, Option 4, Option 5"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}

          {propertyExists("maxHeight") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Height (px)
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="maxHeight"
                value={properties.maxHeight?.replace("px", "") || "250"}
                onChange={(e) =>
                  handlePropertyChange("maxHeight", `${e.target.value}px`)
                }
                placeholder="250"
                min="100"
                max="500"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}

          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}

          {propertyExists("showSelectAll") && (
            <div className="col-6">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showSelectAll"
                  name="showSelectAll"
                  checked={properties.showSelectAll !== false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="showSelectAll"
                  style={{ fontSize: "0.6rem" }}
                >
                  Show "Select All" Option
                </label>
              </div>
            </div>
          )}

          {propertyExists("showSelectedCount") && (
            <div className="col-6">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showSelectedCount"
                  name="showSelectedCount"
                  checked={properties.showSelectedCount !== false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="showSelectedCount"
                  style={{ fontSize: "0.6rem" }}
                >
                  Show Selected Count
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Checkbox Appearance Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Checkbox Appearance
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("checkboxSize") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Checkbox Size
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="checkboxSize"
                value={properties.checkboxSize || "16px"}
                onChange={handleInputChange}
                placeholder="16px"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}

          {propertyExists("checkboxColor") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Checkbox Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="checkboxColor"
                value={properties.checkboxColor || "#0d6efd"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  const renderFileInputSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["file-input"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* File Input Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            File Upload Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("acceptedFileTypes") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Accepted File Types (comma-separated)
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="acceptedFileTypes"
                value={properties.acceptedFileTypes?.join(", ") || ""}
                onChange={(e) =>
                  handlePropertyChange(
                    "acceptedFileTypes",
                    e.target.value.split(",").map((type) => type.trim())
                  )
                }
                placeholder=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
              <small className="text-muted" style={{ fontSize: "0.6rem" }}>
                Use file extensions like .jpg, .pdf or MIME types like
                image/jpeg
              </small>
            </div>
          )}

          {propertyExists("maxFileSize") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Size (MB)
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="maxFileSize"
                value={properties.maxFileSize || 10}
                onChange={handleInputChange}
                placeholder="10"
                min="1"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}

          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}

          {propertyExists("showPreview") && (
            <div className="col-6">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showPreview"
                  name="showPreview"
                  checked={properties.showPreview || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="showPreview"
                  style={{ fontSize: "0.6rem" }}
                >
                  Show Image Preview
                </label>
              </div>
            </div>
          )}

          {propertyExists("dropzoneText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Dropzone Text
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="dropzoneText"
                value={properties.dropzoneText || ""}
                onChange={handleInputChange}
                placeholder="Drag & drop a file or click to browse"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Color Settings */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Button Colors
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("buttonColor") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Button Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="buttonColor"
                value={properties.buttonColor || "#0d6efd"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}

          {propertyExists("buttonTextColor") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Button Text Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="buttonTextColor"
                value={properties.buttonTextColor || "#ffffff"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Border Section */}
      {renderBorderSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );
  // Text Title Section (existing)
  const renderTextTitleSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            // Get default style for this element type
            const defaultStyle = defaultComponentStyle[element.id];
            if (!defaultStyle) return;

            // Create a fresh copy
            const style = JSON.parse(JSON.stringify(defaultStyle));

            // Update local state
            setProperties(style);

            // Use replace mode for a full reset
            dispatch(
              updateStyling({
                id: element.instanceId,
                data: style,
                mode: "replace", // Add this flag
              })
            );

            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Title Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Title Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("titleText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Title Text
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="titleText"
                value={properties.titleText || ""}
                onChange={handleInputChange}
                placeholder="Enter title text"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("headingLevel") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Heading Level
              </label>
              <select
                className="form-select form-select-xs"
                name="headingLevel"
                value={properties.headingLevel || "h1"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="h1">H1</option>
                <option value="h2">H2</option>
                <option value="h3">H3</option>
                <option value="h4">H4</option>
                <option value="h5">H5</option>
                <option value="h6">H6</option>
              </select>
            </div>
          )}
        </div>
      </div>

      {/* Typography Section */}
      {renderTypographySection()}

      {/* Size and Spacing Section */}
      {renderSizeAndSpacingSection()}

      {/* Border Section */}
      {renderBorderSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );
  const renderSectionSettings = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["section"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Section Settings */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Section Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("backgroundColor") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Background Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="backgroundColor"
                value={properties.backgroundColor || "#f8f9fa"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("padding") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Padding
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="padding"
                value={properties.padding || "1rem"}
                onChange={handleInputChange}
                placeholder="1rem"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Size and Spacing Section */}
      {renderSizeAndSpacingSection()}

      {/* Border Section */}
      {renderBorderSection()}
    </div>
  );

  // Number Input Section
  const renderNumberInputSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["number-input"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Number Input Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Number Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("minValue") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Min Value
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="minValue"
                value={properties.minValue || ""}
                onChange={handleInputChange}
                placeholder="Min"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("maxValue") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Value
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="maxValue"
                value={properties.maxValue || ""}
                onChange={handleInputChange}
                placeholder="Max"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("step") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Step
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="step"
                value={properties.step || "1"}
                onChange={handleInputChange}
                placeholder="1"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
          {propertyExists("placeholderText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Placeholder
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="placeholderText"
                value={properties.placeholderText || ""}
                onChange={handleInputChange}
                placeholder="Enter placeholder"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Textarea Section
  const renderTextareaSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["textarea"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Textarea Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Textarea Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("rows") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Rows
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="rows"
                value={properties.rows || "3"}
                onChange={handleInputChange}
                placeholder="3"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("resize") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Resize
              </label>
              <select
                className="form-select form-select-xs"
                name="resize"
                value={properties.resize || "vertical"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="none">None</option>
                <option value="both">Both</option>
                <option value="horizontal">Horizontal</option>
                <option value="vertical">Vertical</option>
              </select>
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
          {propertyExists("placeholderText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Placeholder
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="placeholderText"
                value={properties.placeholderText || ""}
                onChange={handleInputChange}
                placeholder="Enter placeholder"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Checkbox Section
  const renderCheckboxSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["checkbox"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Checkbox Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Checkbox Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("label") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Label
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="label"
                value={properties.label?.label || ""}
                onChange={handleInputChange}
                placeholder="Checkbox label"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("checkboxSize") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Size
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="checkboxSize"
                value={properties.checkboxSize || "16px"}
                onChange={handleInputChange}
                placeholder="16px"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("checkboxColor") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Checkbox Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="checkboxColor"
                value={properties.checkboxColor || "#0d6efd"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Radio Section
  const renderRadioSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["radio"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Radio Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Radio Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("label") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Group Label
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="label"
                value={properties.label?.label || ""}
                onChange={handleInputChange}
                placeholder="Radio group label"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("options") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Options (comma-separated)
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="options"
                value={properties.options?.join(", ") || ""}
                onChange={(e) =>
                  handlePropertyChange(
                    "options",
                    e.target.value.split(",").map((opt) => opt.trim())
                  )
                }
                placeholder="Option 1, Option 2, Option 3"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        
          {propertyExists("optionsLayout") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Options Layout
              </label>
              <select
                className="form-select form-select-xs"
                name="optionsLayout"
                value={properties.optionsLayout || "vertical"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="vertical">Vertical</option>
                <option value="horizontal">Horizontal</option>
              </select>
            </div>
          )}
          {properties.optionsLayout === "horizontal" &&
            propertyExists("optionsPerRow") && (
              <div className="col-6">
                <label
                  className="form-label small mb-0"
                  style={{ fontSize: "0.6rem" }}
                >
                  Options Per Row
                </label>
                <input
                  type="number"
                  className="form-control form-control-xs"
                  name="optionsPerRow"
                  value={properties.optionsPerRow || "2"}
                  onChange={handleInputChange}
                  placeholder="2"
                  min="1"
                  max="6"
                  style={{ fontSize: "0.7rem", height: "1.8rem" }}
                />
              </div>
            )}
          {propertyExists("radioSize") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Size
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="radioSize"
                value={properties.radioSize || "16px"}
                onChange={handleInputChange}
                placeholder="16px"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("radioColor") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Radio Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="radioColor"
                value={properties.radioColor || "#0d6efd"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Select Section
  const renderSelectSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["select"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Select Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Select Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("options") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Options (comma-separated)
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="options"
                value={properties.options?.join(", ") || ""}
                onChange={(e) =>
                  handlePropertyChange(
                    "options",
                    e.target.value.split(",").map((opt) => opt.trim())
                  )
                }
                placeholder="Option 1, Option 2, Option 3"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("placeholderText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Placeholder
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="placeholderText"
                value={properties.placeholderText || ""}
                onChange={handleInputChange}
                placeholder="Select an option"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-12 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Divider Section
  const renderDividerSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["divider"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Divider Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Divider Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("showLabel") && (
            <div className="col-12">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showLabel"
                  name="showLabel"
                  checked={properties.showLabel || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="showLabel"
                  style={{ fontSize: "0.6rem" }}
                >
                  Show Label
                </label>
              </div>
            </div>
          )}
          {properties.showLabel && propertyExists("label") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Label Text
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="label"
                value={properties.label?.label || ""}
                onChange={handleInputChange}
                placeholder="Section Divider"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("thickness") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Thickness
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="thickness"
                value={properties.thickness || "1px"}
                onChange={handleInputChange}
                placeholder="1px"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("opacity") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Opacity
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="opacity"
                value={properties.opacity || "1"}
                onChange={handleInputChange}
                placeholder="1"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("borderStyle") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Style
              </label>
              <select
                className="form-select form-select-xs"
                name="borderStyle"
                value={properties.borderStyle || "solid"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="solid">Solid</option>
                <option value="dashed">Dashed</option>
                <option value="dotted">Dotted</option>
                <option value="double">Double</option>
              </select>
            </div>
          )}
          {propertyExists("color") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Color
              </label>
              <input
                type="color"
                className="form-control form-control-color form-control-xs p-0"
                name="color"
                value={properties.color || "#ced4da"}
                onChange={handleInputChange}
                style={{ height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Spacing Section */}
      <div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Spacing
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("marginTop") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Margin Top
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="marginTop"
                value={properties.marginTop || "1rem"}
                onChange={handleInputChange}
                placeholder="1rem"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("marginBottom") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Margin Bottom
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="marginBottom"
                value={properties.marginBottom || "1rem"}
                onChange={handleInputChange}
                placeholder="1rem"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Text Block Section
  // Replace the existing renderTextBlockSection function in FormBuilderProperties.js

  // Replace the existing renderTextBlockSection function in FormBuilderProperties.js

  const renderTextBlockSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["text"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Text Block Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Text Block Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("label") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Label
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="label"
                value={properties.label?.label || ""}
                onChange={handleInputChange}
                placeholder="Text Block"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("content") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Content
              </label>
              <div className="rich-text-editor">
                <RichTextEditor
                  value={properties.content || ""}
                  onChange={(newContent) =>
                    handlePropertyChange("content", newContent)
                  }
                  style={{ fontSize: "0.7rem" }}
                />
              </div>
              <small className="text-muted" style={{ fontSize: "0.55rem" }}>
                Use the toolbar above to format your text with bold, italic,
                lists, and links. Supports keyboard shortcuts (Ctrl+B, Ctrl+I,
                Ctrl+U).
              </small>
            </div>
          )}
        </div>
      </div>

      {/* Typography Section */}
      {renderTypographySection()}

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}

      <div>
        <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Opacity
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("opacity") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Opacity (0-1)
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="opacity"
                value={properties.opacity || "1"}
                onChange={handleInputChange}
                placeholder="1"
                min="0"
                max="1"
                step="0.1"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // Date Picker Section
  const renderDatePickerSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["date"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Date Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Date Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("minDate") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Min Date
              </label>
              <input
                type="date"
                className="form-control form-control-xs"
                name="minDate"
                value={properties.minDate || ""}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("maxDate") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Date
              </label>
              <input
                type="date"
                className="form-control form-control-xs"
                name="maxDate"
                value={properties.maxDate || ""}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-12 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Time Picker Section
  const renderTimePickerSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["time"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Time Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Time Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("minTime") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Min Time
              </label>
              <input
                type="time"
                className="form-control form-control-xs"
                name="minTime"
                value={properties.minTime || ""}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("maxTime") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Time
              </label>
              <input
                type="time"
                className="form-control form-control-xs"
                name="maxTime"
                value={properties.maxTime || ""}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("step") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Step (seconds)
              </label>
              <input
                type="number"
                className="form-control form-control-xs"
                name="step"
                value={properties.step || "60"}
                onChange={handleInputChange}
                placeholder="60"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("isRequired") && (
            <div className="col-6 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Button Section
  const renderButtonSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["button"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Button Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Button Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("buttonText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Button Text
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="buttonText"
                value={properties.buttonText || ""}
                onChange={handleInputChange}
                placeholder="Submit"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("buttonType") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Button Type
              </label>
              <select
                className="form-select form-select-xs"
                name="buttonType"
                value={properties.buttonType || "button"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="button">Button</option>
                <option value="submit">Submit</option>
                <option value="reset">Reset</option>
              </select>
            </div>
          )}
          {propertyExists("actionType") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Action Type
              </label>
              <select
                className="form-select form-select-xs"
                name="actionType"
                value={properties.actionType || "none"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="none">None</option>
                <option value="submit">Submit Form</option>
                <option value="reset">Reset Form</option>
                <option value="custom">Custom</option>
              </select>
            </div>
          )}
          {propertyExists("showIcon") && (
            <div className="col-12">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="showIcon"
                  name="showIcon"
                  checked={properties.showIcon !== false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="showIcon"
                  style={{ fontSize: "0.6rem" }}
                >
                  Show Icon
                </label>
              </div>
            </div>
          )}
          {properties.showIcon && propertyExists("icon") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Icon Class
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="icon"
                value={properties.icon || "bi-send"}
                onChange={handleInputChange}
                placeholder="bi-send"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {properties.showIcon && propertyExists("iconPosition") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Icon Position
              </label>
              <select
                className="form-select form-select-xs"
                name="iconPosition"
                value={properties.iconPosition || "left"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="left">Left</option>
                <option value="right">Right</option>
              </select>
            </div>
          )}
          {propertyExists("disabled") && (
            <div className="col-12">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="disabled"
                  name="disabled"
                  checked={properties.disabled || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="disabled"
                  style={{ fontSize: "0.6rem" }}
                >
                  Disabled
                </label>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Image Section
  const renderImageSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle["image"])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Image Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Image Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("imageUrl") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Image URL
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="imageUrl"
                value={properties.imageUrl || ""}
                onChange={handleInputChange}
                placeholder="https://example.com/image.jpg"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("altText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Alt Text
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="altText"
                value={properties.altText || ""}
                onChange={handleInputChange}
                placeholder="Image description"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("label") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Label
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="label"
                value={properties.label?.label || ""}
                onChange={handleInputChange}
                placeholder="Image"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("objectFit") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Object Fit
              </label>
              <select
                className="form-select form-select-xs"
                name="objectFit"
                value={properties.objectFit || "cover"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="cover">Cover</option>
                <option value="contain">Contain</option>
                <option value="fill">Fill</option>
                <option value="none">None</option>
                <option value="scale-down">Scale Down</option>
              </select>
            </div>
          )}
          {propertyExists("alignment") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Alignment
              </label>
              <select
                className="form-select form-select-xs"
                name="alignment"
                value={properties.alignment || "center"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="flex-start">Left</option>
                <option value="center">Center</option>
                <option value="flex-end">Right</option>
              </select>
            </div>
          )}
        </div>
      </div>

      {/* Size Settings Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Size Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("width") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Width
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="width"
                value={properties.width || "100%"}
                onChange={handleInputChange}
                placeholder="100%"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("height") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Height
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="height"
                value={properties.height || "auto"}
                onChange={handleInputChange}
                placeholder="auto"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
          {propertyExists("maxWidth") && (
            <div className="col-6">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Max Width
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="maxWidth"
                value={properties.maxWidth || "100%"}
                onChange={handleInputChange}
                placeholder="100%"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Border Section */}
      {renderBorderSection()}
    </div>
  );

  // Common sections that can be reused
  const renderLabelSection = () => (
    <div className="pb-2 mb-2" style={{ borderBottom: "1px solid #787C7EFF" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Label Settings
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("label") && (
          <div className="col-12">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Label
            </label>
            <input
              type="text"
              className="form-control form-control-xs"
              name="label"
              value={properties.label?.label || ""}
              onChange={handleInputChange}
              placeholder="Enter label"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("labelPosition") && (
          <div className="col-12">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Position
            </label>
            <select
              className="form-select form-select-xs"
              name="labelPosition"
              value={properties.labelPosition || "top"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="top">Top</option>
              <option value="bottom">Bottom</option>
              <option value="left">Left</option>
              <option value="right">Right</option>
            </select>
          </div>
        )}
      </div>
    </div>
  );
  const renderTypographySection = () => (
    <div className="pb-2 mb-2" style={{ borderBottom: "1px solid #787C7EFF" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Typography
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("fontFamily") && (
          <div className="col-12">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Font Family
            </label>
            <select
              className="form-select form-select-xs"
              name="fontFamily"
              value={properties.fontFamily || "inherit"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="inherit">Inherit</option>
              <option value="Arial, sans-serif">Arial</option>
              <option value="Helvetica, sans-serif">Helvetica</option>
              <option value="'Times New Roman', serif">Times New Roman</option>
              <option value="Georgia, serif">Georgia</option>
              <option value="'Courier New', monospace">Courier New</option>
              <option value="Verdana, sans-serif">Verdana</option>
              <option value="'Trebuchet MS', sans-serif">Trebuchet MS</option>
              <option value="'Arial Black', sans-serif">Arial Black</option>
              <option value="Impact, sans-serif">Impact</option>
              <option value="'Comic Sans MS', cursive">Comic Sans MS</option>
              <option value="system-ui, -apple-system, sans-serif">
                System UI
              </option>
            </select>
          </div>
        )}
        {propertyExists("fontSize") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Font Size
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="fontSize"
              value={getValueWithoutUnit(properties.fontSize, "16")}
              onChange={handleNumericInputChange}
              placeholder="16"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("fontWeight") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Font Weight
            </label>
            <select
              className="form-select form-select-xs"
              name="fontWeight"
              value={properties.fontWeight || "normal"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
              <option value="bolder">Bolder</option>
              <option value="lighter">Lighter</option>
            </select>
          </div>
        )}
        {propertyExists("fontStyle") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Font Style
            </label>
            <select
              className="form-select form-select-xs"
              name="fontStyle"
              value={properties.fontStyle || "normal"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="normal">Normal</option>
              <option value="italic">Italic</option>
              <option value="oblique">Oblique</option>
            </select>
          </div>
        )}
        {propertyExists("textAlign") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Text Align
            </label>
            <select
              className="form-select form-select-xs"
              name="textAlign"
              value={properties.textAlign || "left"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
              <option value="justify">Justify</option>
            </select>
          </div>
        )}

        {propertyExists("letterSpacing") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Letter Spacing
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="letterSpacing"
              value={
                properties.letterSpacing === "normal" ||
                !properties.letterSpacing
                  ? ""
                  : getValueWithoutUnit(properties.letterSpacing, "")
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || value === "0") {
                  handlePropertyChange("letterSpacing", "normal");
                } else {
                  handlePropertyChange("letterSpacing", `${value}px`);
                }
              }}
              placeholder="0"
              step="0.1"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
      </div>
    </div>
  );
  const renderStyleSection = () => (
    <div className="pb-2 mb-2" style={{ borderBottom: "1px solid #787C7EFF" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Styling
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("width") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Width
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="width"
              value={
                properties.width === "100%"
                  ? "100"
                  : getValueWithoutUnit(properties.width, "")
              }
              onChange={handleNumericInputChange}
              placeholder="100"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("height") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Height
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="height"
              value={
                properties.height === "auto"
                  ? ""
                  : getValueWithoutUnit(properties.height, "")
              }
              onChange={handleNumericInputChange}
              placeholder="Auto"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("padding") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Padding
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="padding"
              value={getValueWithoutUnit(properties.padding, "0.5")}
              onChange={handleNumericInputChange}
              placeholder="0.5"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
      </div>

      {/* Margin sub-section */}
      <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Margin
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("marginBottom") && (
          <div className="col-3">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Bottom
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="marginBottom"
              value={getValueWithoutUnit(properties.marginBottom, "0.5")}
              onChange={handleNumericInputChange}
              placeholder="0.5"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("marginTop") && (
          <div className="col-3">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Top
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="marginTop"
              value={getValueWithoutUnit(properties.marginTop, "0.5")}
              onChange={handleNumericInputChange}
              placeholder="0.5"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("marginRight") && (
          <div className="col-3">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Right
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="marginRight"
              value={getValueWithoutUnit(properties.marginRight, "0.5")}
              onChange={handleNumericInputChange}
              placeholder="0.5"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("marginLeft") && (
          <div className="col-3">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Left
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="marginLeft"
              value={getValueWithoutUnit(properties.marginLeft, "0.5")}
              onChange={handleNumericInputChange}
              placeholder="0.5"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
      </div>
    </div>
  );

  const renderBorderSection = () => (
    <div className="pb-2 mb-2" style={{ borderBottom: "1px solid #787C7EFF" }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Border
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("borderStyle") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Border Style
            </label>
            <select
              className="form-select form-select-xs"
              name="borderStyle"
              value={properties.borderStyle || "solid"}
              onChange={handleInputChange}
              style={{ fontSize: "0.7rem", height: "2rem" }}
            >
              <option value="none">None</option>
              <option value="solid">Solid</option>
              <option value="dashed">Dashed</option>
              <option value="dotted">Dotted</option>
              <option value="double">Double</option>
            </select>
          </div>
        )}
        {propertyExists("borderWidth") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Border Width
            </label>
            <UnitInput
              name="borderWidth"
              value={properties.borderWidth || "1px"}
              onChange={handleUnitPropertyChange}
              placeholder="1"
              units={["px", "rem", "em"]}
            />
          </div>
        )}
        {propertyExists("borderRadius") && (
          <div className="col-6">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Border Radius
            </label>
            <UnitInput
              name="borderRadius"
              value={properties.borderRadius || "0.25rem"}
              onChange={handleUnitPropertyChange}
              placeholder="0.25"
              units={["px", "rem", "em", "%"]}
            />
          </div>
        )}
      </div>
    </div>
  );

  const renderColorSection = () => (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
          Colors
        </h6>
      </div>
      <div className="row g-2">
        {propertyExists("borderColor") && (
          <div className="col-4">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Border
            </label>
            <input
              type="color"
              className="form-control form-control-color form-control-xs p-0"
              name="borderColor"
              value={properties.borderColor || "#ced4da"}
              onChange={handleInputChange}
              style={{ height: "1.8rem" }}
            />
          </div>
        )}
        {propertyExists("backgroundColor") && (
          <div className="col-4">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Background
            </label>
            <input
              type="color"
              className="form-control form-control-color form-control-xs p-0"
              name="backgroundColor"
              value={properties.backgroundColor || "#FFFFFF"}
              onChange={handleInputChange}
              style={{ height: "1.8rem" }}
            />
          </div>
        )}
        {(propertyExists("textColor") || propertyExists("color")) && (
          <div className="col-4">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Text
            </label>
            <input
              type="color"
              className="form-control form-control-color form-control-xs p-0"
              name={properties.textColor !== undefined ? "textColor" : "color"}
              value={properties.textColor || properties.color || "#495057"}
              onChange={handleInputChange}
              style={{ height: "1.8rem" }}
            />
          </div>
        )}
        {/* Add background opacity control */}
        {propertyExists("backgroundOpacity") && (
          <div className="col-12">
            <label
              className="form-label small mb-0"
              style={{ fontSize: "0.6rem" }}
            >
              Background Opacity (0-1)
            </label>
            <input
              type="number"
              className="form-control form-control-xs"
              name="backgroundOpacity"
              value={properties.backgroundOpacity || "1"}
              onChange={handleInputChange}
              placeholder="1"
              min="0"
              max="1"
              step="0.1"
              style={{ fontSize: "0.7rem", height: "1.8rem" }}
            />
          </div>
        )}
      </div>
    </div>
  );

  const renderSizeAndSpacingSection = () => (
    <div className="pb-2 mb-2" style={{ borderBottom: "1px solid #787C7EFF" }}>
      {/* Same as renderStyleSection for most use cases */}
      {renderStyleSection()}
    </div>
  );

  // Default section for unknown element types
  const renderDefaultSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      <div className="text-center p-3">
        <p className="text-muted">
          No customization options available for this element type.
        </p>
      </div>
    </div>
  );

  // Text Input Section (updated from original)
  const renderTextInputSection = () => (
    <div
      className={`${
        activeSection === "customize" ? "d-block" : "d-none"
      } mt-0 pt-0`}
    >
      {/* Universal Reset Button */}
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-secondary btn-xs"
          onClick={() => {
            var style = JSON.parse(
              JSON.stringify(defaultComponentStyle[element.id])
            );
            setProperties(style);
            dispatch(updateStyling({ id: element.instanceId, data: style }));
            onPropertiesChange?.(style);
          }}
          style={{ fontSize: "0.6rem", padding: "0.15rem 0.3rem" }}
        >
          <i className="bi bi-arrow-counterclockwise"></i> Reset All
        </button>
      </div>

      {/* Label Settings Section */}
      {renderLabelSection()}

      {/* Input Type and Validation Section */}
      <div
        className="pb-2 mb-2"
        style={{ borderBottom: "1px solid #787C7EFF" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="text-dark mb-0" style={{ fontSize: "0.7rem" }}>
            Input Settings
          </h6>
        </div>
        <div className="row g-2">
          {propertyExists("inputType") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Input Type
              </label>
              <select
                className="form-select form-select-xs"
                name="inputType"
                value={properties.inputType || "text"}
                onChange={handleInputChange}
                style={{ fontSize: "0.7rem", height: "2rem" }}
              >
                <option value="email">Email</option>

                <option value="mobile">Phone</option>
                <option value="text">Text</option>
              </select>
            </div>
          )}
          {/* {propertyExists("isRequired") && (
            <div className="col-4 d-flex align-items-end">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={properties.isRequired || false}
                  onChange={handleInputChange}
                />
                <label
                  className="form-check-label small"
                  htmlFor="isRequired"
                  style={{ fontSize: "0.6rem" }}
                >
                  Required
                </label>
              </div>
            </div>
          )} */}
          {propertyExists("placeholderText") && (
            <div className="col-12">
              <label
                className="form-label small mb-0"
                style={{ fontSize: "0.6rem" }}
              >
                Placeholder
              </label>
              <input
                type="text"
                className="form-control form-control-xs"
                name="placeholderText"
                value={properties.placeholderText || ""}
                onChange={handleInputChange}
                placeholder="Enter placeholder"
                style={{ fontSize: "0.7rem", height: "1.8rem" }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Styling Section */}
      {renderStyleSection()}

      {/* Color Section */}
      {renderColorSection()}
    </div>
  );

  // Main render
  return (
    <>
      <div
        className="btn-group btn-group-sm"
        role="group"
        style={{
          height: "1.5rem",
          width: "5vw",
          display: "inline-flex",
        }}
      >
        <button
          className={`btn btn-xs ${
            activeSection === "customize" ? "btn-primary" : "btn-white"
          }`}
          style={{
            fontSize: "0.6rem",
            padding: "0.15rem 0.3rem",
            lineHeight: "1",
            width: "auto",
            borderRadius: "3px 3px 3px 0px",
          }}
          onClick={() => setActiveSection("customize")}
        >
          Customize
        </button>
        <button
          className={`btn btn-xs ${
            activeSection === "validate" ? "btn-primary" : "btn-white"
          }`}
          style={{
            fontSize: "0.6rem",
            padding: "0.15rem 0.3rem",
            lineHeight: "1",
            width: "auto",
          }}
          onClick={() => setActiveSection("validate")}
        >
          Validate
        </button>
      </div>
      <div
        className="card shadow-sm m-0"
        style={{
          border: "1px solid #e9ecef",
          borderTop: "",
          borderRadius: "0px 3px 3px 3px",
        }}
      >
        <div className="card-body p-2 pe-3">
          {renderCustomizationByElementType()}
          {renderValidationSection()}
        </div>
      </div>
    </>
  );
}

export default FormBuilderPropertiesPanel;
